module.exports = __webpack_public_path__ + "img/vr-bg.cc1c1781.jpg";